import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import type { AddtionalStockEntity } from "../../Objects/Addtional/AddtionalStockEntity"
import { PutRequest } from "../../services/ApiClientService"

interface AdditionalStockQuickEditRequest {
  items: AddtionalStockEntity[]
}

export type AdditionalStockTarget = "product" | "catalogItem" | "combo"

const ADDITIONAL_STOCK_ENDPOINT_BY_TARGET: Record<AdditionalStockTarget, string> = {
  product: API_ROUTES.PRODUCT.ADDITIONAL_STOCK,
  catalogItem: API_ROUTES.CATALOG_ITEM.ADDITIONAL_STOCK,
  combo: API_ROUTES.COMBO.ADDITIONAL_STOCK,
}

export const useSaveAdditionalStock = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const saveAdditionalStock = async (
    target: AdditionalStockTarget,
    items: AddtionalStockEntity[],
  ): Promise<boolean> => {
    if (items.length === 0) return true

    try {
      enableLoad()

      const response = await PutRequest<number[], AdditionalStockQuickEditRequest>(
        ADDITIONAL_STOCK_ENDPOINT_BY_TARGET[target],
        { items },
      )

      if (!response.success) throw new Error(response.message)

      return true
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { saveAdditionalStock }
}
